import axios from 'axios';
import { wpData } from './wpConfig';

export const wpInstance = axios.create({
  baseURL: wpData.restUrl
});
